import Select from "./input/select";
import React from "react";
import {useTranslation} from "next-i18next";

/**
 *
 */
type Data = {
    id : string
    name : string
    defaultValue : string
}

/**
 *
 * @param id
 * @param name
 * @param defaultValue
 * @constructor
 */
export default function Language({ id, name, defaultValue } : Data) {
    // init
    const { t } = useTranslation();

    // init options
    const options = [
        {key: "default", value: "", display: t('choose.language'), disabled: true},
        {key: "en", value: "en", display: 'English', disabled: false},
        {key: "de", value: "de", display: 'Deutsch', disabled: false}
    ];

    // render
    return (
        <Select
            id={id}
            name={name}
            defaultValue={defaultValue}
            options={options}
        />
    );
}